import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../../../common/html/button'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { selectUserType } from '../../../../../layout/store/slice'
import { PopupUpgrade } from '../../../../../userManagement/subscriptionPayment/common/popupUpgrade'
import { USER_TYPE } from '../../../../../utils/authorization'
import classes from './index.module.scss'

export const BlockCurrentPlan = () => {
  const [isShowViewPlan, setIsShowViewPlan] = useState(false)

  const userType = useSelector(selectUserType)

  const upGradeAction = () => {
    setIsShowViewPlan(true)
  }

  return (
    <>
      <Element
        elementName="div"
        style={{ backgroundColor: '#F3F3F3' }}
        className={classes.blockCurrentPlan}
      >
        <div className={['dFlex alignItemsCenter', classes.title].join(' ')}>
          <Element
            elementName="span"
            style={{ fontSize: 20 }}
            className="fw600"
          >
            <Translate value="domesticSearchPreview.CURRENT_PLAN" />
          </Element>
          <Element
            elementName="div"
            className={[
              'dFlex alignItemsCenter ml1',
              classes.tagCurrentPlan,
            ].join(' ')}
            style={{ color: '#3DA967' }}
          >
            <Icon
              className="icon-tick-circle-fill mr1"
              style={{ fontSize: 10 }}
            />
            {userType.userTypeId === USER_TYPE.BASIC ? 'Basic' : 'Lite'}
          </Element>
        </div>
        <div className={classes.description}>
          <Translate value="domesticSearchPreview.CURRENT_PLAN_DESCRIPTION" />
        </div>
        <div className="dFlex justifyContentEnd">
          <Button
            label="domesticSearchPreview.UPGRADE_NOW"
            isI18n
            style={{ backgroundColor: '#FFCD60', fontSize: 20 }}
            action={upGradeAction}
            className={[
              'px3 py1 fw600 cursorPointer textUppercase',
              classes.button,
            ].join(' ')}
          />
        </div>
      </Element>
      {isShowViewPlan && (
        <PopupUpgrade isShow={isShowViewPlan} setIsShow={setIsShowViewPlan} />
      )}
    </>
  )
}
